import ApplicationController from './application_controller'

export default class extends ApplicationController {
	connect() {
		this.setToastExpiration()
	}	

	closeToast() {
		this.hideToast()
		setTimeout(() => { this.removeToastElement() }, 375 )
		//this.removeToastElement()
	}

	setToastExpiration() {
		setTimeout(() => { this.hideToast() }, 7125)
		setTimeout(() => { this.removeToastElement() }, 7500 )
	}

	showToast() {
		this.element.classList.add('show')
		this.element.classList.remove('hide')
	}

	hideToast() {
		if (this.element) {
			this.element.classList.add('toast-close')
		}
	}

	removeToastElement() {
		if (this.element.parentNode) {
			this.element.parentNode.removeChild(this.element)
		}
	}
}
